export default __webpack_public_path__ + "static/media/block_exercise.424c35b5.svg";